import Select, { GroupBase } from "react-select";
import { CustomDropdownIndicator, EmptyOptions, MultiSelectOption, selectStyle } from "./SelectInputUtils";

export interface OptionType {
    [key: string]: any;
}

interface MultiSelectProps<T extends OptionType> {
    options: T[];
    value: T[] | null;
    onChange: (value: T[] | null) => void;
    placeholder?: string;
    onLoadMore?: () => void;
    hasMore?: boolean;
    getOptionValue?: (option: T) => string;
    getOptionLabel?: (option: T) => string;
    onSearch?: (value: string) => void;
    height?: "small" | "medium" | "xs";
}

export function MultiSelect<T extends OptionType>({
    options,
    value,
    onChange,
    placeholder = "Select...",
    onLoadMore,
    hasMore = false,
    getOptionValue = option => JSON.stringify(option),
    getOptionLabel = option => JSON.stringify(option),
    onSearch,
    height = "medium"
}: MultiSelectProps<T>) {
    return (
        <Select<T, true, GroupBase<T>>
            data-height={height}
            options={options}
            value={value as any}
            onChange={val => onChange(val as any)}
            isMulti
            isSearchable
            placeholder={placeholder}
            getOptionValue={getOptionValue}
            getOptionLabel={getOptionLabel}
            onMenuScrollToBottom={() => {
                if (hasMore && onLoadMore) onLoadMore();
            }}
            onInputChange={val => {
                if (onSearch) onSearch(val);
                return val;
            }}
            menuPortalTarget={document.body}
            styles={selectStyle(height)}
            menuPosition="absolute"
            menuPlacement="auto"
            components={{
                Option: MultiSelectOption,
                DropdownIndicator: CustomDropdownIndicator,
                IndicatorSeparator: () => null,
                NoOptionsMessage: EmptyOptions
            }}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
        />
    );
}
